import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from 'next-themes'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem={true}
          disableTransitionOnChange={true}
          storageKey="tailtations-theme"
        >
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)

// Fade out and remove the instant HTML preloader (index.html) once the app has
// painted. Two RAFs ensure React has committed + the browser has painted a
// frame before we start the fade, so there's no flash of blank content.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const preloader = document.getElementById('app-preloader')
    if (!preloader) return
    preloader.classList.add('app-preloader--hide')
    const remove = () => preloader.remove()
    // Both event names: WebKit/older iOS Safari fires webkitTransitionEnd.
    preloader.addEventListener('transitionend', remove, { once: true })
    preloader.addEventListener('webkitTransitionEnd', remove, { once: true })
    // Fallback removal in case neither transitionend event fires (iOS quirks).
    setTimeout(remove, 700)
  })
})
